// authService.js - All Firebase Authentication Operations
import { 
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider,
  sendEmailVerification,
  sendPasswordResetEmail,
  signOut as firebaseSignOut
} from 'firebase/auth';
import { auth } from '../firebase';

// ============================================
// EMAIL/PASSWORD AUTHENTICATION
// ============================================

export const signUpWithEmail = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    await sendEmailVerification(userCredential.user);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('❌ Sign up error:', error);
    throw error;
  }
};

export const signInWithEmail = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('❌ Sign in error:', error);
    throw error;
  }
};

// ============================================
// SOCIAL AUTHENTICATION
// ============================================

export const signInWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('❌ Google sign in error:', error);
    throw error;
  }
};

export const signInWithFacebook = async () => {
  try {
    const provider = new FacebookAuthProvider();
    const result = await signInWithPopup(auth, provider);
    return { success: true, user: result.user };
  } catch (error) {
    console.error('❌ Facebook sign in error:', error);
    throw error;
  }
};

// ============================================
// PASSWORD RESET
// ============================================

export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return { success: true, message: 'Password reset email sent' };
  } catch (error) {
    console.error('❌ Password reset error:', error);
    throw error;
  }
};

// ============================================
// SIGN OUT
// ============================================

export const signOut = async () => {
  try {
    await firebaseSignOut(auth);
    return { success: true };
  } catch (error) {
    console.error('❌ Sign out error:', error);
    throw error;
  }
};

// ============================================
// AUTH STATE OBSERVER
// ============================================

export const onAuthStateChange = (callback) => {
  return auth.onAuthStateChanged(callback);
};
